// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--dXr_P","form":"contact-module--form--1GPPK","success":"contact-module--success--2ZWkd","error":"contact-module--error--aNP7x"};